import { gql } from '@apollo/client';

const faqPagesQuery = gql`
  query Page($id: ID!) {
    page(id: $id, idType: URI) {
      slug
      title
      uri
      seo {
        metaDesc
        title
        opengraphUrl
        twitterDescription
        twitterImage {
          sourceUrl
        }
        twitterTitle
        opengraphImage {
          sourceUrl
        }
      }
      sections {
        components {
          fieldGroupName
          ... on SectionsComponentsDevicelocationsLayout {
            fieldGroupName
            title
          }
          ... on SectionsComponentsTeamLayout {
            person {
              role
              name
              email
              social {
                facebook
                instagram
                linkedin
                twitter
              }
              image {
                node {
                  sourceUrl
                  title
                  mimeType
                }
              }
            }
            small
            subtitle
            title
          }
          ... on SectionsComponentsHeroLayout {
            fieldGroupName
            cta2 {
              title
              url
              file {
                node {
                  caption
                  title
                  link
                }
              }
              icon
            }
            cta1 {
              title
              url
              file {
                node {
                  caption
                  title
                  link
                }
              }
              page {
                node {
                  ... on Page {
                    uri
                    title
                  }
                }
              }
              icon
            }
            title
            subtitle
            word
            image {
              node {
                sourceUrl
                title
                mimeType
              }
            }
          }
          ... on SectionsComponentsHeroContactLayout {
            fieldGroupName
            cta2 {
              title
              url
              file {
                node {
                  caption
                  title
                  link
                }
              }
              icon
            }
            cta1 {
              title
              url
              file {
                node {
                  caption
                  title
                  link
                }
              }
              page {
                node {
                  ... on Page {
                    uri
                    title
                  }
                }
              }
              icon
            }
            title
            word
            image {
              node {
                sourceUrl
                title
                mimeType
              }
            }
            locations {
              address
              phone
              title
              geo {
                lat
                lon
              }
            }
          }
          ... on SectionsComponentsHeroHomeLayout {
            fieldGroupName
            cta1 {
              fieldGroupName
              title
              url
              file {
                node {
                  caption
                  title
                  link
                }
              }
              page {
                node {
                  ... on Page {
                    uri
                    title
                  }
                }
              }
              icon
            }
            cta2 {
              fieldGroupName
              title
              url
              file {
                node {
                  caption
                  title
                  link
                }
              }
              page {
                node {
                  ... on Page {
                    uri
                    title
                  }
                }
              }
              icon
            }
            subtitle
            title
            word
            media {
              fieldGroupName
              preview {
                node {
                  caption
                  title
                  sourceUrl
                }
              }
              video {
                node {
                  caption
                  title
                  link
                }
              }
            }
          }
          ... on SectionsComponentsTestimonialsLayout {
            description
            fieldGroupName
            title
            testimonials {
              date
              message
              name
              rating
            }
          }
          ... on SectionsComponentsCarouselalignLayout {
            fieldGroupName
            cards {
              fieldGroupName
              subtitle
              title
              word
              cta1 {
                fieldGroupName
                title
                url
                file {
                  node {
                    caption
                    title
                    link
                  }
                }
                page {
                  node {
                    ... on Page {
                      uri
                      title
                    }
                  }
                }
                icon
              }
              image {
                node {
                  sourceUrl
                  title
                  mimeType
                }
              }
            }
          }
          ... on SectionsComponentsCarouselsmallLayout {
            fieldGroupName
            subtitle
            title
            word
            cards {
              fieldGroupName
              subtitle
              title
              cta1 {
                fieldGroupName
                title
                url
                file {
                  node {
                    caption
                    title
                    link
                  }
                }
                page {
                  node {
                    ... on Page {
                      uri
                      title
                    }
                  }
                }
                icon
              }
              image {
                node {
                  sourceUrl
                  title
                  mimeType
                }
              }
            }
          }
          ... on SectionsComponentsGridLayout {
            fieldGroupName
            subtitle
            title
            gridCards {
              fieldGroupName
              title
              image {
                node {
                  sourceUrl
                  title
                  mimeType
                }
              }
              properties {
                title
                subtitle
              }
            }
            gridCards {
              fieldGroupName
              title
              properties {
                title
                subtitle
              }
            }
          }
          ... on SectionsComponentsListLayout {
            fieldGroupName
            subtitle
            title
            word
            listCards {
              fieldGroupName
              icon
              subtitle
              title
              image {
                node {
                  sourceUrl
                  title
                  mimeType
                }
              }
              highlights {
                icon
                text
              }
            }
          }
          ... on SectionsComponentsSimpleactionLayout {
            title
            subtitle
            cta1 {
              fieldGroupName
              title
              url
              file {
                node {
                  caption
                  title
                  link
                }
              }
              page {
                node {
                  ... on Page {
                    uri
                    title
                  }
                }
              }
              icon
            }
          }
          ... on SectionsComponentsFaqsLayout {
            fieldGroupName
            subtitle
            title
            word
            categories {
              icon
              title
              faqs {
                answer
                question
              }
            }
          }
        }
      }
      template {
        ... on Template_FAQ {
          templateName
          faq {
            fieldGroupName
            title
          }
        }
      }
    }
  }
`;

export default faqPagesQuery;
